import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import AnswerSpot from './AnswerSpot';

export default class PuzzleDisplay extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.rowCount = 4;
    this.colCount = 3;

    this.connectedTiles = null;

    /** @type {AnswerSpot[]} */
    this.tiles = [];
    this.tileWidth = this.scene.textures.getFrame(ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._outside_circle2).realWidth + 15;
    this.tileHeight = this.scene.textures.getFrame(ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._outside_circle2).realHeight - 45;
  }

  checkDropCollision (x,y,radius) {
    const len = this.tiles.length;
    let distance = 0;
    let shortestDistance = 999999;
    let collidedWith = null;
    for (let i = 0; i < len; i++) {
      distance = Phaser.Math.Distance.Between(x,y,this.tiles[i].x, this.tiles[i].y);
      if (distance < radius + this.tiles[i].workingWidth / 2) {
        if (distance < shortestDistance) {
          shortestDistance = distance;
          collidedWith = this.tiles[i];
        }
      }
    }
    return collidedWith;
  }

  displayPuzzle (tileMatrix, paths, puzzleNumber) {
    let xPad = 0;
    let yPad = 0;
    let rowPad = 0;
    let colPad = 0;
    let colPad1 = 0;
    let colPad2 = 0;

    let rowPad1 = 0;
    let rowPad2 = 0;
    let xPad1 = 0;
    let xPad2 = 0;

    // this switch and numbers below are a great big hack to retrofit
    // the 2d puzzle display to a 3D slanted display -- as rows are closer
    // the tiles are spaced wider
    switch (puzzleNumber) {
      case 0:
        xPad = 50;
        yPad = 18;
        rowPad = 0;
        colPad = 0;
        break;

      case 1:
        xPad = -22;
        yPad = 18;
        rowPad = -39;
        colPad = -2;
        break;

      case 2:
        xPad = 50;
        yPad = 16;
        rowPad = 0;
        colPad = -4;
        break;

      case 3:
        xPad = -22;
        xPad2 = -26;
        yPad = 20;
        rowPad = -39;
        rowPad2 = -38;
        colPad = -2;
        colPad2 = -4;
        break;

      case 4:
        xPad = 92;
        xPad2 = 60;
        yPad = 12;
        rowPad = -45;
        rowPad2 = -12;
        colPad = -4;
        colPad2 = -2;
        break;

      case 5:
        xPad = -22;
        yPad = 20;
        rowPad = -39;
        colPad = -2;
        break;

      case 6:
        xPad = 92;
        xPad1 = 92;
        yPad = 10;
        rowPad = -44;
        rowPad1 = -44;
        colPad = -4;
        colPad1 = -10;
        colPad2 = -1;
        rowPad2 = 8;
        xPad2 = 40;
        break;

      case 7:
        xPad = 44;
        xPad1 = 16;
        xPad2 = -20;
        yPad = 20;
        rowPad = 8;
        rowPad1 = 36;
        rowPad2 = 70;
        colPad = -2;
        colPad1 = -12;
        colPad2 = 0;
        break;

      case 8:
        xPad = -22;
        yPad = 20;
        rowPad = -39;
        colPad = -2;
        break;

      case 9:
        xPad = 50;
        yPad = 16;
        xPad1 = 33;
        xPad2 = 18;
        rowPad = -2;
        rowPad1 = 15;
        rowPad2 = 32;
        colPad = -2;
        colPad1 = -6;
        break;

      case 10:
        xPad = 20;
        xPad1 = -37;
        xPad2 = -27;
        yPad = 16;
        rowPad = -32;
        rowPad1 = 1;
        rowPad2 = -2;
        colPad = -6;
        colPad1 = -6;
        colPad2 = -2;
        break;

      case 11:
        xPad = 38;
        xPad1 = 18;
        xPad2 = -10;
        yPad = 16;
        rowPad = 17;
        rowPad1 = 36;
        rowPad2 = 60;
        colPad = -4;
        colPad1 = -8;
        colPad2 = 1;
        break;

      case 12:
        xPad = 34;
        xPad1 = 1;
        xPad2 = -8;
        yPad = 16;
        rowPad = -30;
        rowPad1 = -8;
        rowPad2 = -8;
        colPad = -4;
        colPad1 = 4;
        break;
    }
    this.clearPuzzle();
    this.tileMatrix = tileMatrix;
    this.connectedTiles = paths;

    const usedTiles = [].concat(...this.connectedTiles);

    const rowLen = this.tileMatrix.length;
    let colLen = 0;
    let item = null;
    const padding = this.tileWidth / 2 + 2;

    this.tiles = [];
    let i = 0;
    for (let row = 0; row < rowLen; row++) {
      colLen = this.tileMatrix[row].length;
      for (let col = 0; col < colLen; col++) {
        if (usedTiles.indexOf(i) >= 0) {
          item = new AnswerSpot(this.scene, i);

          // items are invisible with new graphics -- just needed as drag targets
          item.alpha = 0;

          const itemBounds = item.getBounds();
          item.iterate(child => child.setPosition(child.x - itemBounds.width / 2, child.y - itemBounds.height / 2));

          if (rowPad1 !== 0 && col === 1) {
            item.x = ((this.tileWidth + rowPad1) * row) + (padding * row) + xPad1;
            item.y = ((this.tileHeight + colPad1) * col) + (padding * col) + yPad;
          }
          else if (rowPad2 !== 0 && col === 2) {
            item.x = ((this.tileWidth + rowPad2) * row) + (padding * row) + xPad2;
            item.y = ((this.tileHeight + colPad2) * col) + (padding * col) + yPad;
          }
          else {
            item.x = ((this.tileWidth + rowPad) * row) + (padding * row) + xPad;
            item.y = ((this.tileHeight + colPad) * col) + (padding * col) + yPad;
          }
          this.tiles.push(item);
          this.add(item);
        }
        i++;
      }
    }
  }

  clearPuzzle () {
    this.tileMatrix = null;
    this.connectedTiles = null;

    const len = this.tiles.length;
    for (let i = 0; i < len; i++) {
      this.tiles[i].destroy();
      this.tiles[i] = null;
    }
  }
}